import ReactECharts from 'echarts-for-react';

export default function GaugeChart(props) {
    var series = props.series;
    const theme = props.theme;
    console.log(series)
    
    const unitMap = {
        "IAVG": " A",  // Amperes
        "KVAT": " KVA",  // Watts
        "V_LLAVG": " V", // Volts 
        "PFT": " PF"   // Power Factor (No unit)
    };
    if (series) {
        // Ensure correct unit formatting based on name

        // Update series details with correct formatting
        series["detail"] = {
            valueAnimation: true,
            formatter: `{value}${unitMap[series.data[0]?.name] || ""}`,
            color: 'inherit',
            offsetCenter: [0, '95%'],
            fontSize: 24,
        };

        series["axisTick"] = {
            distance: -29,
            length: 30,
            lineStyle: { color: 'white', width: 1 }
        };

        series["splitLine"] = {
            distance: -29,
            length: 30,
            lineStyle: { color: theme === 'dark' ? 'inherit' : 'white', width: 1 }
        };
        // series["axisLabel"]={
        //     color: theme === 'dark' ? 'inherit' : 'white',
        // }
    }
    console.log(series)
    console.log(theme)

    return (   
        <div className='overflow-hidden h-[270px] shadow-allsides hover:scale-105 duration-150'>
            <ReactECharts
                option={{
                    series: series,
                    tooltip: {
                        show: true,
                        formatter: `{a} <br/>{b} : {c}${unitMap[series.data[0]?.name] || ""}`,
                        triggerOn: 'mousemove', 
                    },
                    title: {
                        text: series.title,
                        left: 'left',
                        padding: 10,
                    },
                }}
                className='w-[270px] h-[150px] m-0 rounded-lg'
                theme={props.theme}
            />
        </div>
    );
}
